import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const features = ['6 Tomos — más de 300 páginas', '6 Bonos exclusivos de implementación', 'Tracker de Desinflamación 21 días', 'Ruta de compra para supermercados españoles', 'Kit SOS Antojos de uso inmediato', 'Guía Social para comer fuera en España', 'PDF descargable — acceso en 5 minutos', 'Actualizaciones gratuitas de por vida'];
  const handleClick = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Sistema Mimetismo Nutricional',
      value: 19.9,
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-134" data-mp="3h9hddq265g04">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-135" data-mp="3c8jx5j0pyw19">
        Accede al sistema completo
      </h2>
      <p className="text-center text-brand-secondary font-semibold mb-8 font-body" data-id="element-136" data-mp="3vynlio2kwdf5">
        Acceso completo e inmediato
      </p>

      <div className="flex justify-center mb-6" data-id="element-137" data-mp="4uyuqzbug69q">
        <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" className="w-full max-w-[220px] object-contain" loading="lazy" data-id="element-138" data-mp="9ta4zb61wish" />
      </div>

      <div className="max-w-lg mx-auto bg-white border-2 border-brand-primary rounded-3xl p-8 md:p-10 shadow-card-lg" data-id="element-139" data-mp="3i7ipdvyf639k">
        <h3 className="font-heading text-lg font-bold text-brand-title mb-1 text-center" data-id="element-140" data-mp="3n63qdxlhwqz2">
          Sistema Mimetismo Nutricional™
        </h3>
        <p className="text-brand-textMuted text-sm font-body mb-6 text-center" data-id="element-141" data-mp="3rzy50mm8ufra">
          6 Tomos + 6 Bonos Exclusivos
        </p>

        <div className="space-y-3 mb-8" data-id="element-142" data-mp="2zh0zs08vvnsf">
          {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-143" data-mp="2zf7twn63h7lh" data-mpi={i}>
              <CheckIcon className="w-5 h-5 text-brand-primary shrink-0 mt-0.5" data-id="element-144" data-mp="2rfjuj9slggki" />
              <span className="font-body text-brand-text text-sm" data-id="element-145" data-mp="2mgqizmwvazmz">
                {feature}
              </span>
            </div>)}
        </div>

        <div className="text-center border-t border-brand-border pt-6 mb-6" data-id="element-146" data-mp="318qx6mvy9igw">
          <div className="font-display text-5xl font-black text-brand-title mb-1" data-id="element-147" data-mp="2w83a2caudlry">
            €19,90
          </div>
          <div className="text-brand-textMuted text-sm font-body" data-id="element-148" data-mp="28k3acmvjyl18">
            Pago único · Sin suscripción · Acceso de por vida
          </div>
        </div>

        <a href="https://www.manualeslistos.com/cart/62909676814666:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="font-heading w-full bg-brand-primary hover:bg-brand-primaryHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-colors text-center block shadow-card mb-3" data-id="element-149" data-mp="2ih7w4llhkehi">
          Quiero acceso inmediato →
        </a>

        <div className="text-center text-brand-textMuted text-xs font-body mb-4" data-id="element-150" data-mp="anbcf44a2p8">
          Pago único · Acceso digital inmediato
        </div>

        <div className="flex items-center justify-center gap-4 text-xs text-brand-textMuted font-body" data-id="element-151" data-mp="5a9okojy3iy1">
          <span data-id="element-152" data-mp="3ngo0yj2kfkub">🔒 Pago seguro SSL</span>
          <span data-id="element-153" data-mp="3rgos94arjqis">↩ Garantía 30 días</span>
          <span data-id="element-154" data-mp="3rhq1r4c4s4ye">⚡ Acceso en 5 min</span>
        </div>
      </div>
    </Section>;
}